import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/business/leads/templates/$templateId")({
    beforeLoad: ({ params, search }) => {
        throw redirect({ to: "/sales/leads/templates/$templateId", params, search, replace: true });
    },
});
